<template>
  <div v-if="showAllDays" class="comments-grid comments-grid--header" :style="gridStyle">
    <div v-for="dayIndex in visibleDayIndexes" :key="dayIndex" class="day-name">
      <span>{{ getDayHeader(dayIndex).name }}</span>
      <span v-if="getDayHeader(dayIndex).date" class="day-name__date">
        {{ getDayHeader(dayIndex).date }}
      </span>
    </div>
  </div>
  <div class="comments-grid" :style="gridStyle">
    <div v-for="dayIndex in visibleDayIndexes" :key="dayIndex">
      <div class="day">
        <div v-if="!showAllDays" class="day-name">
          <span>{{ getDayHeader(dayIndex).name }}</span>
          <span v-if="getDayHeader(dayIndex).date" class="day-name__date">
            {{ getDayHeader(dayIndex).date }}
          </span>
        </div>
        <template v-for="(item, itemIndex) in items[dayIndex]" :key="`${dayIndex}-${itemIndex}`">
          <template v-if="item.type === 'comment'">
            <DietCommentEditor
              v-if="editedComment === `${dayIndex}-${itemIndex}`"
              :comment="getComment(item.mealIndex, item.dayIndex, item.commentIndex)"
              @title="emit('title', item, $event)"
              @content="emit('content', item, $event)"
            />
            <div v-else-if="!item.comment" class="add-comment-box">
              <StyledButton
                v-if="editable"
                left-icon="add"
                variant="outline"
                @click.stop="emit('edit', `${dayIndex}-${itemIndex}`)"
              >
                Dodaj komentarz
              </StyledButton>
            </div>
            <DietCommentCard
              v-else
              :comment="item.comment"
              :editable="editable"
              @edit="emit('edit', `${dayIndex}-${itemIndex}`)"
              @delete="emit('delete', item)"
            />
          </template>
          <DietMealSummary v-else :meal="item.meal" />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { StyledButton } from '@/components/StyledButton'

  import type { DietCommentGridItem, DietCommentViewModel } from '../../types'
  import DietCommentCard from '../DietCommentCard/DietCommentCard.vue'
  import DietCommentEditor from '../DietCommentEditor/DietCommentEditor.vue'
  import DietMealSummary from '../DietMealSummary/DietMealSummary.vue'

  defineProps<{
    getDayHeader: (index: number) => { date?: string; name: string }
    editable: boolean
    editedComment?: string
    getComment: (
      mealIndex: number,
      dayIndex: number,
      commentIndex: number,
    ) => { content: string; title: string }
    gridStyle: Record<string, string>
    items: DietCommentGridItem[][]
    showAllDays: boolean
    visibleDayIndexes: number[]
  }>()
  const emit = defineEmits<{
    content: [item: DietCommentViewModel, value: string]
    delete: [item: DietCommentViewModel]
    edit: [key: string]
    title: [item: DietCommentViewModel, value: string]
  }>()
</script>
